
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.49 1.25H2.51A2.5 2.5 0 000 3.72v14.06a2.5 2.5 0 002.51 2.47h10.16c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H2.51A1.5 1.5 0 011 17.78V3.72c0-.81.68-1.47 1.51-1.47h18.98c.83 0 1.51.66 1.51 1.47v3.03c0 .28.22.5.5.5s.5-.22.5-.5V3.72a2.5 2.5 0 00-2.51-2.47z"}}),_c('path',{attrs:{"d":"M3.9 15.6a.49.49 0 00.7 0l4.5-4.5a.5.5 0 000-.71L4.6 5.9c-.2-.2-.51-.2-.71 0s-.2.51 0 .71l4.15 4.15L3.9 14.9a.5.5 0 000 .71zm3.77.95h3.83c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H7.67c-.28 0-.5.22-.5.5s.22.5.5.5zm15.83-3.03h-2.9l2.01-2.94c.25-.37.28-.84.07-1.24a1.06 1.06 0 00-.95-.59h-3.78c-.4 0-.76.23-.95.6l-2.86 5.5c-.19.37-.18.82.04 1.18.2.33.54.53.92.53h1.23l-1.58 4.56a1.2 1.2 0 00.44 1.47c.17.11.37.17.56.17.27 0 .54-.11.76-.33l7.37-8.06a.51.51 0 00.09-.54.5.5 0 00-.46-.3zm-7.83 8.17s-.05-.11 0-.23l1.82-5.24c.05-.15.03-.32-.07-.45s-.25-.21-.41-.21l-1.99-.05s-.04-.12 0-.19l2.93-5.55 3.84.05s.04.13 0 .21l-2.55 3.72a.49.49 0 00-.03.52c.09.16.26.27.44.27h2.7l-6.68 7.17z"}})])
          )
        }
      }
    